/* MRB form client — contact, request-a-quote, newsletter.
 *
 * These are plain <form data-mrb-form="..."> elements (NOT Shopify {% form %}
 * tags), submitted as JSON to the mrb-forms Lambda. Shopify's /contact
 * endpoint — and therefore its risk-based /challenge captcha — is never
 * involved (site principle: zero captchas). Because they aren't Shopify
 * forms, the storefront forms shim leaves them alone and preventDefault
 * works normally, so we get inline success/error states with no page reload.
 *
 * Field collection: every input/textarea/select named contact[Label] is sent
 * as {"Label": value} (checkbox chips only when checked), so the existing
 * field markup — including the contact block's _custom-field child blocks —
 * needs no changes. contact[email] and the honeypot travel separately.
 */
(function () {
  'use strict';

  if (window.__mrbFormsWired) return;
  window.__mrbFormsWired = true;

  var ENDPOINT = 'https://jhxv5d4i37uedeowc65ijokoje0vakys.lambda-url.us-east-2.on.aws/';
  var NAME_RE = /^contact\[(.+)\]$/;
  var FILE_MAX = 4 * 1000 * 1000; // 4 MB — mirrors the Lambda's cap
  var FILE_EXTS = ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.csv', '.txt',
                   '.png', '.jpg', '.jpeg'];

  function fileOk(file) {
    if (!file) return true;
    if (file.size > FILE_MAX) return false;
    var name = (file.name || '').toLowerCase();
    return FILE_EXTS.some(function (ext) {
      return name.length > ext.length && name.lastIndexOf(ext) === name.length - ext.length;
    });
  }

  function fileError(input, show) {
    var field = input.closest('.rq-field, .form-field') || input.parentElement;
    var msg = field && field.querySelector('[data-mrb-file-error]');
    if (msg) msg.hidden = !show;
  }

  function updateFilebox(input) {
    var field = input.closest('.rq-field, .form-field') || input.parentElement;
    var box = field && field.querySelector('[data-mrb-filebox]');
    if (!box) return;
    var name = box.querySelector('[data-mrb-file-name]');
    var clear = box.querySelector('[data-mrb-file-clear]');
    if (name && !name.hasAttribute('data-empty') && !box.classList.contains('has-file')) {
      name.setAttribute('data-empty', name.textContent);
    }
    var file = input.files && input.files[0];
    if (file) {
      box.classList.add('has-file');
      if (name) {
        name.textContent = file.name + ' (' + Math.max(1, Math.round(file.size / 1024)) + ' KB)';
      }
      if (clear) clear.hidden = false;
    } else {
      box.classList.remove('has-file');
      if (name) name.textContent = name.getAttribute('data-empty') || '';
      if (clear) clear.hidden = true;
    }
  }

  function readAttachment(input) {
    return new Promise(function (resolve, reject) {
      var file = input && input.files && input.files[0];
      if (!file) { resolve(null); return; }
      var reader = new FileReader();
      reader.onload = function () {
        var data = String(reader.result).split(',')[1] || '';
        resolve({ name: file.name, type: file.type || '', data: data });
      };
      reader.onerror = function () { reject(new Error('read_failed')); };
      reader.readAsDataURL(file);
    });
  }

  // validate on selection so bad files are flagged before submit
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.hasAttribute || !input.hasAttribute('data-mrb-attach')) return;
    var file = input.files && input.files[0];
    if (file && !fileOk(file)) {
      input.value = '';
      fileError(input, true);
    } else {
      fileError(input, false);
    }
    updateFilebox(input);
  }, true);

  // "×" clears the picked file
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest
      && event.target.closest('[data-mrb-file-clear]');
    if (!btn) return;
    event.preventDefault();
    var field = btn.closest('.rq-field, .form-field');
    var input = field && field.querySelector('input[data-mrb-attach]');
    if (!input) return;
    input.value = '';
    fileError(input, false);
    updateFilebox(input);
  }, true);

  // drag & drop onto the filebox
  ['dragover', 'dragleave', 'drop'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      var box = event.target && event.target.closest
        && event.target.closest('[data-mrb-filebox]');
      if (!box) return;
      event.preventDefault();
      if (type === 'dragover') { box.classList.add('is-dragover'); return; }
      box.classList.remove('is-dragover');
      if (type !== 'drop') return;
      var field = box.closest('.rq-field, .form-field');
      var input = field && field.querySelector('input[data-mrb-attach]');
      var files = event.dataTransfer && event.dataTransfer.files;
      if (!input || !files || !files.length) return;
      try { input.files = files; } catch (e) { return; }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);
  });

  function collect(form) {
    var payload = { fields: {} };
    var els = form.querySelectorAll('input[name], textarea[name], select[name]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var m = NAME_RE.exec(el.name);
      if (!m) continue;
      var label = m[1];
      var value = (el.value || '').trim();
      if (el.hasAttribute('data-mrb-honeypot')) {
        payload.website = el.value || '';
      } else if (label === 'email') {
        payload.email = value;
      } else if (el.type === 'checkbox' || el.type === 'radio') {
        if (el.checked && value) payload.fields[label] = value;
      } else if (value) {
        payload.fields[label] = value;
      }
    }
    return payload;
  }

  function setBusy(form, busy) {
    var btn = form.querySelector('[type="submit"]');
    if (!btn) return;
    btn.disabled = busy;
    if (busy) {
      btn.setAttribute('data-label', btn.textContent);
      var sending = form.getAttribute('data-sending-label') || 'Sending…';
      var labelEl = btn.querySelector('.btn__text') || btn;
      labelEl.textContent = sending;
    } else if (btn.getAttribute('data-label')) {
      var restoreEl = btn.querySelector('.btn__text') || btn;
      restoreEl.textContent = btn.getAttribute('data-label');
    }
  }

  function show(form, which) {
    var wrap = form.closest('[data-mrb-form-wrap]') || form.parentElement;
    var success = wrap.querySelector('[data-mrb-form-success]');
    var error = wrap.querySelector('[data-mrb-form-error]');
    if (error) error.hidden = which !== 'error';
    if (which === 'success' && success) {
      form.hidden = true;
      success.hidden = false;
      success.setAttribute('tabindex', '-1');
      try { success.focus({ preventScroll: false }); } catch (e) { /* noop */ }
    }
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-mrb-form')) return;
    event.preventDefault();
    if (!form.reportValidity()) return;

    var attachInput = form.querySelector('input[data-mrb-attach]');
    if (attachInput && attachInput.files && attachInput.files[0]
        && !fileOk(attachInput.files[0])) {
      fileError(attachInput, true);
      attachInput.focus();
      return;
    }

    var payload = collect(form);
    payload.form = form.getAttribute('data-mrb-form');
    setBusy(form, true);
    show(form, 'none');

    readAttachment(attachInput)
      .then(function (attachment) {
        if (attachment) payload.attachment = attachment;
        return fetch(ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
      })
      .then(function (res) { return res.json().catch(function () { return {}; }); })
      .then(function (data) {
        if (data && data.ok) {
          show(form, 'success');
        } else {
          show(form, 'error');
        }
      })
      .catch(function () { show(form, 'error'); })
      .finally(function () { setBusy(form, false); });
  }, true);
})();
